"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/stickyNotification/stickyNotification.theme/genesis/stickyNotification.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class StickyNotification extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(StickyNotification), "StickyNotification", []);
            this.TestDatas = StickyNotification.TestDatas;
            this.BindedLists = StickyNotification.BindedLists;
            this.BindedWidgets = StickyNotification.BindedWidgets;
            this.InitialData = StickyNotification.InitialData;
            this.path = StickyNotification.path;
            this.GeneratedConstructor = StickyNotification;
            if (StickyNotification.InitialData) {
                this.renderRecursive(StickyNotification.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.StickyNotification",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("div", { "data-theme": { "name": "data-theme", "templates": [{ "type": "raw", "content": "genesis" }] }, "aria-live": { "name": "aria-live", "templates": [{ "type": "raw", "content": "polite" }] }, "aria-relevant": { "name": "aria-relevant", "templates": [{ "type": "raw", "content": "additions text" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "sticky-notification-982fbc" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("div", { "data-list": { "name": "data-list", "templates": [{ "type": "raw", "content": "stickyNotificationList" }] } }, []), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = [{ "name": "default", "content": "", "json": { "stickyNotificationList": [{}] } }]; }
        static { this.BindedLists = [{ "name": "stickyNotificationList", "type": "void", "reference": null }]; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/stickyNotification/stickyNotification.theme/genesis/stickyNotification"; }
        static { this.widgetName = "StickyNotification"; }
        static { this.InitialData = null; }
    }
    R.StickyNotification = StickyNotification;
    StickyNotification["prototype"].widgetName = "StickyNotification";
    (function (StickyNotification) {
        var _b;
        class StickyNotificationListItem extends Leaf.GeneratedWidget {
            static { _b = Leaf.CompileInfoSymbol; }
            constructor() {
                super(Leaf.WidgetThemeCenter.getThemeGenerator(StickyNotificationListItem), "StickyNotificationListItem", []);
                this.TestDatas = StickyNotificationListItem.TestDatas;
                this.BindedLists = StickyNotificationListItem.BindedLists;
                this.BindedWidgets = StickyNotificationListItem.BindedWidgets;
                this.InitialData = StickyNotificationListItem.InitialData;
                this.path = StickyNotificationListItem.path;
                this.GeneratedConstructor = StickyNotificationListItem;
                if (StickyNotificationListItem.InitialData) {
                    this.renderRecursive(StickyNotificationListItem.InitialData);
                }
            }
            static { this[_b] = WidgetCompileInfo && {
                ...WidgetCompileInfo,
                namespace: "R.StickyNotification.StickyNotificationListItem",
            }; }
            static { this.generator = function () {
                var _e = this._e.bind(this);
                var _t = this._t.bind(this);
                return _e("section", { "data-theme": { "name": "data-theme", "templates": [{ "type": "raw", "content": "genesis" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "sticky-notification-list-item-f7eeb6 sticky-notification-item" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n        " }] }), _e("div", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "content" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "content" }] } }, []), _t({ "templates": [{ "type": "raw", "content": "\n    " }] })]);
            }; }
            static { this.TestDatas = []; }
            static { this.BindedLists = []; }
            static { this.BindedWidgets = []; }
            static { this.path = "/script/stickyNotification/stickyNotification.theme/genesis/stickyNotification/stickyNotificationListItem"; }
            static { this.widgetName = "StickyNotificationListItem"; }
            static { this.InitialData = null; }
        }
        StickyNotification.StickyNotificationListItem = StickyNotificationListItem;
        StickyNotificationListItem["prototype"].widgetName = "StickyNotificationListItem";
    })(StickyNotification = R.StickyNotification || (R.StickyNotification = {}));
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.sticky-notification-982fbc {\n\n    & {\n        position: absolute;\n        z-index: 1;\n        left: 20px;\n        bottom: 64px;\n        width: 360px;\n        max-width: calc(100vw - 40px);\n        pointer-events: none;\n    }\n\n    [data-list] {\n        display: flex;\n        flex-direction: column-reverse;\n        gap: 10px;\n    }\n\n    .sticky-notification-item {\n        width: 100%;\n        overflow: hidden;\n        border: 1px solid rgba(255, 255, 255, .12);\n        background: #202224;\n        box-shadow: 0 12px 30px rgba(0, 0, 0, .28);\n        pointer-events: auto;\n    }\n\n    .content {\n        padding: 14px 16px;\n    }\n\n    @media (max-width: 560px) {\n        & {\n            left: 12px;\n            bottom: 56px;\n            max-width: calc(100vw - 24px);\n        }\n    }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
